import React from 'react';
import styled, { css } from 'styled-components';
import COLORS from '../../../constants/COLORS';
import Error from './Error';

const Checkbox = ({ name, id, children, onChange, checked, error }: any) => {
  const handleChange = ({ target }) => {
    onChange(name, target.checked);
  };

  return (
    <div>
      <StyledCheckbox
        name={name}
        type="checkbox"
        id={id}
        checked={checked}
        onChange={handleChange}
      />
      <label htmlFor={id}>{children}</label>
      {error && <Error>{error}</Error>}
    </div>
  );
};

export default Checkbox;

const StyledCheckbox = styled.input`
  position: absolute;
  opacity: 0;

  & + label {
    position: relative;
    cursor: pointer;
    padding: 0 0 0 23px;
    display: block;

    ${(props) =>
      props.theme.isRtl &&
      css`
        padding: 0 23px 0 0;
      `}
  }

  & + label:before {
    position: absolute;
    left: 0;
    top: 0;
    content: '';
    margin-right: 10px;
    display: inline-block;
    vertical-align: text-top;
    width: 13px;
    height: 14px;
    border-radius: 3px;

    border: ${({ theme }) => `1px solid ${theme.buttonBackground || COLORS.BLUE}`};
    background: white;

    ${({ theme }) =>
      theme.isRtl &&
      css`
        margin-right: unset;
        margin-left: 10px;
        left: unset;
        right: 0;
      `}
  }

  &:hover + label:before {
    background: ${({ theme }) => theme.buttonBackground || COLORS.BLUE};
  }

  &:checked + label:before {
    background: ${({ theme }) => theme.buttonBackground || COLORS.BLUE};
  }

  &:disabled + label {
    color: #b8b8b8;
    cursor: auto;
  }

  &:disabled + label:before {
    box-shadow: none;
    background: #ddd;
  }

  &:checked + label:after {
    content: '';
    position: absolute;
    left: 2px;
    top: 7px;
    background: white;
    width: 2px;
    height: 2px;
    box-shadow: 2px 0 0 white, 4px 0 0 white, 4px -2px 0 white, 4px -4px 0 white, 4px -6px 0 white,
      4px -8px 0 white;
    transform: rotate(45deg);

    ${({ theme }) =>
      theme.isRtl &&
      css`
        left: unset;
        right: 11px;
      `}
  }
`;
